// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"47c434bf","453":"5a540433"}[chunkId] + ".chunk.js";
};